export default function CommentIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 14L11.2 11.2H1.4C1.015 11.2 0.685417 11.0629 0.41125 10.7887C0.137083 10.5146 0 10.185 0 9.8V1.4C0 1.015 0.137083 0.685417 0.41125 0.41125C0.685417 0.137083 1.015 0 1.4 0H12.6C12.985 0 13.3146 0.137083 13.5887 0.41125C13.8629 0.685417 14 1.015 14 1.4V14ZM1.4 9.8H11.795L12.6 10.5875V1.4H1.4V9.8Z"
        fill="#4448C1"
      />
    </svg>
  );
}
